<div class="question-overview-list">
  <div class="question-overview-container">
    <div class="table">
      <div class="scroll-container">
        <div class="tab-header list">
          <div class="position text-style" data-cy="positionHeader">
            <div class="td-content header-cell" (click)="toggleSort('srNo')">
              Nr. @if (currentSort?.column === 'srNo') { @if
              (currentSort?.direction === 'asc') {
              <mat-icon>arrow_drop_up</mat-icon>
              } @if (currentSort?.direction === 'desc') {
              <mat-icon>arrow_drop_down</mat-icon>
              } }
            </div>
          </div>
          <div class="question text-style" data-cy="questionHeader">
            <div class="td-content header-cell" (click)="toggleSort('text')">
              {{ 'question.label.question' | translate }}
              @if (currentSort?.column === 'text') { @if (currentSort?.direction
              === 'asc') {
              <mat-icon>arrow_drop_up</mat-icon>
              } @if (currentSort?.direction === 'desc') {
              <mat-icon>arrow_drop_down</mat-icon>
              } }
            </div>
          </div>
          <div
            class="score right-or-wrong text-style"
            (click)="sort('rightWrong')"
          >
            <div
              class="td-content header-cell"
              (click)="toggleSort('num_correct_answers')"
            >
              {{ 'question.label.rightWrongUnanswered' | translate }}
              @if (currentSort?.column === 'num_correct_answers') { @if
              (currentSort?.direction === 'asc') {
              <mat-icon>arrow_drop_up</mat-icon>
              } @if (currentSort?.direction === 'desc') {
              <mat-icon>arrow_drop_down</mat-icon>
              } }
            </div>
          </div>
          <div class="result text-style" (click)="sort('result')">
            <div
              class="td-content header-cell"
              (click)="toggleSort('correctPercentage')"
            >
              {{ 'exam.result.result' | translate }}
              @if (currentSort?.column === 'correctPercentage') { @if
              (currentSort?.direction === 'asc') {
              <mat-icon>arrow_drop_up</mat-icon>
              } @if (currentSort?.direction === 'desc') {
              <mat-icon>arrow_drop_down</mat-icon>
              } }
            </div>
          </div>
        </div>
        @if (questions?.length) {
        <div
          class="table-body"
          [qaDynamicHeight]="questions"
          childSelector=".list"
        >
          <ng-scrollbar>
            @for (question of questions; track question.id; let i = $index) {
            <div
              class="list table-border"
              (click)="getQuestionResult(question, i)"
              data-cy="list"
            >
              <div class="position table-data-style">{{ question?.srNo }}</div>
              <div class="question table-data-style" data-cy="questionText">
                <div class="question-text">{{ question?.text }}</div>
                @if ( !isLiveEvent && !question.is_poll_question &&
                question.type === questionType.FREETEXT &&
                question.openQuestionAnsweredCount > 0 ) {
                <div class="question-chip score">
                  <qa-custom-chip
                    [label]="
                      'exam.result.ungradedAnswers'
                        | translate
                          : { count: question.openQuestionAnsweredCount }
                    "
                  ></qa-custom-chip>
                </div>
                }
              </div>
              <div class="score right-or-wrong" data-cy="scoreRightOrWrong">
                <div class="td-content">
                  @if ( !isLiveEvent && question?.is_poll_question) { } @else {
                  @if ( question?.type !== questionType.FREETEXT &&
                  !question?.is_poll_question) {
                  <div class="bar">
                    <div
                      [style.width]="getRightResult(question)"
                      class="right-ans"
                    ></div>
                    <div
                      [style.width]="getWrongResult(question)"
                      class="wrong-ans"
                    ></div>
                  </div>
                  <span
                    >{{ question.num_correct_answers }}/{{
                      question.total_result - question.num_correct_answers
                    }}{{
                      !hideUnAnswered ? '/' + question.num_unanswered : ''
                    }}</span
                  >
                  } @else {
                  <span class="open-question-indicator">
                    {{
                      'exam.result.numOfAnswer'
                        | translate : { count: question.total_num_answers }
                    }}
                  </span>
                  } }
                </div>
              </div>
              <div class="result table-data-style" data-cy="resultPercentage">
                @if ( !isLiveEvent && question?.is_poll_question) {
                <span class="survey-question-text">{{
                  'common.label.surveyQuestion' | translate
                }}</span>
                } @else {
                {{
                  question?.is_poll_question ||
                  question.type === questionType.FREETEXT
                    ? '---'
                    : question.correctPercentage + '%'
                }}
                }
              </div>
            </div>
            }
          </ng-scrollbar>
        </div>
        }
      </div>
    </div>
  </div>
</div>
